<template>
  <div class="add-benefit-container">
    <el-dialog class="add-benefit-dialog" :title="titleMap[controlType]" :visible.sync="dialogVisible" width="680px"
      @close="onClose">
      <div class="add-benefit-content">
        <el-form :model="formData" ref="the-form" label-width="150px" class="demo-formData">
          <el-form-item label="权益名称" required>
            <el-input class="w470" v-model="formData.name" type="text" placeholder="请输入名称" maxlength="10"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="跳转链接">
            <el-input class="w470" v-model="formData.jumpInfo" type="text" placeholder="请输入跳转链接"></el-input>
            <span class="linkTip">链接需包含 .isvjcloud.com , .isvbjd.com或 .jd.com ;只能以 http:// ， https:// 开头</span>
          </el-form-item>

          <el-form-item label="权益icon(已激活)：" style="margin-right: 50px" required>
            <div class="unload-content flexc-cen-x">
              <el-upload :class="[
                'img-uploader',
                activeFileList.length ? 'hide-upload-btn' : '',
              ]" action="/jd-hd-web/image/upload" :file-list="activeFileList" list-type="picture-card"
                :on-success="(file) => { return handleUpload(file, '1'); }" :before-upload="beforeActiveUpload"
                :on-preview="handlePictureCardPreview" :on-remove="onActiveRemove">
                <i class="el-icon-plus img-uploader-icon"></i>
              </el-upload>
              <div class="unload-tip flexc-cen-x">
                <span>建议尺寸：88*88px</span>
                <span>格式：jpg、png</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="权益icon(未激活)：" style="margin-right: 50px" required>
            <div class="unload-content flexc-cen-x">
              <el-upload :class="[
                'img-uploader',
                disabledFileList.length ? 'hide-upload-btn' : '',
              ]" action="/jd-hd-web/image/upload" :file-list="disabledFileList" list-type="picture-card"
                :on-success="(file) => { return handleUpload(file, '2'); }" :before-upload="beforeDefaultUpload"
                :on-preview="handlePictureCardPreview" :on-remove="onDefaultRemove">
                <i class="el-icon-plus img-uploader-icon"></i>
              </el-upload>
              <div class="unload-tip flexc-cen-x">
                <span>建议尺寸：88*88px</span>
                <span>格式：jpg、png</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="previewDialogVisible" :show-close="false" class="preview-dialog" width="300px">
      <template #title></template>
      <img class="img" width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { createMemberBenefitInfo } from "@/api/paradiseAndTaskCommonController.js";

const useFormData = () => {
  return {
    name: "",
    jumpInfo: "", // 跳转链接
    benefitDisableIconUrl: "",
    benefitEnableIconUrl: "",
  };
};
/**
 *添加/编辑权益
 */
export default {
  name: "AddBenefit",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    controlType: {
      type: String,
      default: "",
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      titleMap: {
        add: "添加权益",
        edit: "编辑权益",
      },
      formData: useFormData(),
      submitLoading: false,

      activeFileList: [],
      disabledFileList: [],

      previewDialogVisible: false,
      dialogImageUrl: "",
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
      this.activeFileList = [];
      this.disabledFileList = [];
      if (val) {
        this.formData = useFormData();
        if (this.controlType == "edit") {
          // 替换 modifyData 方法，手动复制属性
          this.formData.name = this.rowData.name || "";
          this.formData.jumpInfo = this.rowData.jumpInfo || "";
          this.formData.benefitDisableIconUrl = this.rowData.benefitDisableIconUrl || "";
          this.formData.benefitEnableIconUrl = this.rowData.benefitEnableIconUrl || "";

          this.activeFileList = this.rowData.benefitEnableIconUrl
            ? [{ url: this.rowData.benefitEnableIconUrl }]
            : [];
          this.disabledFileList = this.rowData.benefitDisableIconUrl
            ? [{ url: this.rowData.benefitDisableIconUrl }]
            : [];
        }
      }
    },
  },
  methods: {
    onClose() {
      this.$emit("input", false);
    },
    async onSubmit() {
      if (!this.formData.name) {
        return this.$message.warning("权益名称不可为空");
      }
      if (!this.formData.benefitEnableIconUrl) {
        return this.$message.warning("权益icon(已激活)不可为空");
      }
      if (!this.formData.benefitDisableIconUrl) {
        return this.$message.warning("权益icon(未激活)不可为空");
      }
      // 验证跳转链接格式
      if (this.formData.jumpInfo) {
        const urlPattern = /^https?:\/\/.+/;
        const domainPattern = /\.(isvjcloud\.com|isvbjd\.com|jd\.com)/;

        if (!urlPattern.test(this.formData.jumpInfo)) {
          return this.$message.warning("跳转链接必须以 http:// 或 https:// 开头");
        }

        if (!domainPattern.test(this.formData.jumpInfo)) {
          return this.$message.warning("跳转链接必须包含 .isvjcloud.com, .isvbjd.com 或 .jd.com 域名");
        }
      }

      try {
        let params = {
          ...this.formData,
        };
        if (this.controlType == 'edit') params.id = this.rowData.id
        this.submitLoading = true;
        // 保存接口/新建接口
        const res = await createMemberBenefitInfo(params);
        this.submitLoading = false;
        if (res.code == 200 || res.code === 1) {
          this.$message.success(
            this.controlType == "edit" ? "编辑成功" : "添加成功"
          );
          this.onClose();
          this.$emit("update");
        } else {
          this.$message.error(res.message);
        }
      } catch (err) {
        this.$message.error(err);
        this.submitLoading = false;
      }
    },

    beforeActiveUpload(file) {
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      let isLt300 = file.size / 1024 <= 300;
      if (!isJPG) {
        this.$message.info("权益icon（激活）图片格式不符合要求，请重新上传!");
        this.activeFileList = [];
      }
      if (!isLt300) {
        this.$message.info("权益icon（激活）图片大小不符合要求，请重新上传!");
        this.activeFileList = [];
      }
      return isJPG && isLt300;
    },

    onActiveRemove() {
      this.activeFileList = [];
      this.formData.benefitEnableIconUrl = "";
    },

    // 上传成功处理
    handleUpload(res, type) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        if (type === "1") {
          this.formData.benefitEnableIconUrl = res.data;
          // 更新文件列表
          this.activeFileList = [{ url: res.data }];
        } else if (type === "2") {
          this.formData.benefitDisableIconUrl = res.data;
          // 更新文件列表
          this.disabledFileList = [{ url: res.data }];
        }
      }
    },

    beforeDefaultUpload(file) {
      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      let isLt300 = file.size / 1024 <= 300;
      if (!isJPG) {
        this.$message.info("权益icon（未激活）图片格式不符合要求，请重新上传!");
        this.disabledFileList = [];
      }
      if (!isLt300) {
        this.$message.info("权益icon（未激活）图片大小不符合要求，请重新上传!");
        this.disabledFileList = [];
      }
      return isJPG && isLt300;
    },

    onDefaultRemove() {
      this.disabledFileList = [];
      this.formData.benefitDisableIconUrl = "";
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.previewDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.w470 {
  width: 470px;
}

.linkTip {
  display: inline-block;
  color: #f56c6c;
  line-height: 22px;
}

/deep/ .el-input__inner {
  width: 470px;
}

/deep/.el-dialog__footer {
  padding-top: 18px !important;
  border-top: 1px solid #f2f2f2;
}

.add-benefit-container {
  .add-benefit-dialog {
    .jump-toggle {
      width: 470px;
      height: 60px;
      display: flex;
      align-items: center;
      background-color: #f7f8fa;
      margin-top: 16px;

      /deep/ .el-input__inner {
        width: 260px !important;
      }

      .helper {
        font-size: 12px;
        color: #3159ff;
        cursor: pointer;
      }

      span {
        margin-left: 10px;
        color: #999999;
      }
    }

    .unload-content {
      .img-uploader {
        width: 72px;
        height: 72px;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #d9d9d9;
        position: relative;
        overflow: hidden;
      }

      /deep/ .el-upload {
        width: 72px;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none !important;
        border-radius: 3px !important;
      }

      /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 100%;
        height: 72px;
        border: none;
        background-color: #fff;
        border-radius: 3px !important;
      }

      .hide-upload-btn {
        /deep/ .el-upload--picture-card {
          display: none !important;
        }
      }

      .unload-tip {
        font-size: 12px;
        color: #999999;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 20px;
        line-height: 18px;
      }
    }
  }
}

.preview-dialog {
  /deep/ .el-dialog__header {
    display: none !important;
  }

  /deep/.el-dialog__body {
    padding: 0px !important;
    border-radius: 8px !important;
  }

  .img {
    border-radius: 8px;
  }
}
</style>